import React from 'react';
import PropTypes from 'prop-types';

import {OELanguageType} from '../../../react-oe/oe-types';
import OETextField from './oe-text-field';
import {OELanguagePickerButton} from '../oe-language-picker';
import OEToolbox from '../../../lib/tools/oe-toolbox';

export class OELStringTextField extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.value = this.props.value;

        this.language = this.props.language;

        this.state = {
            text: this.textFromValue(this.value),
            language: this.language
        };

        this.onChange = this.onChange.bind(this);
        this.onLanguageChange = this.onLanguageChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.language !== this.props.language)   {
            this.setLanguage(nextProps.language);
        }

        if(nextProps.value !== this.props.value)    {
            this.updateValue(nextProps);
        }
    }

    textFromValue(value)    {
        if(!value)  return '';
        let langCode = OELanguageType.toCode(this.language);
        let str = value.getRaw(langCode);
        return str ? str : '';
    }

    setLanguage(language)   {
        if(language == this.language)   return;
        this.language = language;
        this.setState({language: this.language});
        this.updateText();
    }

    updateValue(props)  {
        props = props || this.props;
        if(props.value === this.value)   return;
        this.value = props.value;
        this.updateText();
    }

    updateText()    {
        this.setState({text: this.textFromValue(this.value)});
    }

    render()    {
        const {moduleId, className, popoverClassName, popoverPlacement, boundariesElement, popoverTarget, hidePopoverArrow, onChange, ...rest} = this.props;

        return (
            <div className={'l-string-text-field ' + (this.props.disabled ? 'disabled ' : '') + (className ? className : '')}>
                <div className="container">
                    <OETextField
                        {...rest}
                        value={this.state.text}
                        onChange={this.onChange}
                    />

                    <OELanguagePickerButton
                        moduleId={moduleId}
                        popoverClassName={popoverClassName}
                        boundariesElement={boundariesElement}
                        target={popoverTarget}
                        placement={popoverPlacement}
                        hideArrow={hidePopoverArrow}
                        disabled={this.props.disabled}
                        language={this.state.language}
                        onChange={this.onLanguageChange}
                    />
                </div>
            </div>
        );
    }

    onChange(sender, str)   {
        let newValue = this.value ? this.value.clone() : new LString();
        let langCode = OELanguageType.toCode(this.language);
        newValue.set(str ? str : null, langCode);
        if(newValue && this.value && OEToolbox.shallowEqual(newValue.stringMap, this.value.stringMap, true))  return;
        if(this.props.onChange) this.props.onChange(this, newValue);
    }

    onLanguageChange(language)  {
        this.setLanguage(language)
    }
}

OELStringTextField.defaultProps = Object.assign({}, OETextField.defaultProps, {
    moduleId: '',
    popoverClassName: '',
    popoverPlacement: 'right',
    hidePopoverArrow: false,
    value: null,
    language: OELanguageType.english
});

OELStringTextField.propTypes = Object.assign({}, OETextField.propTypes, {
    moduleId: PropTypes.string,
    popoverClassName: PropTypes.string,
    popoverPlacement: PropTypes.string,
    hidePopoverArrow: PropTypes.bool,
    value: PropTypes.object
});